window.addEventListener('load', () => {
	console.log(document.querySelectorAll('.hal-productCard--wrapper'));
	document.querySelectorAll('.hal-productCard--wrapper').forEach((wrapper) => {
		wrapper.classList.add('loaded');
	});
});
let closeButtons = [...document.getElementsByClassName('close')],
	halImageContainer = [
		...document.getElementsByClassName('hal--image--container'),
	],
	dots = [...document.querySelectorAll('.hal--image--container .hal-dot')],
	cards = [
		...document.querySelectorAll('.hal--image--container .hal-productCard'),
	],
	halImageContainerBg = [...document.querySelectorAll('.hal-productCard--bg')];

closeButtons.forEach((button) => {
	button.addEventListener('click', () => {
		resetHal();
	});
});
halImageContainerBg.forEach((bg) => {
	bg.addEventListener('click', () => {
		resetHal();
	});
});
console.log("610H02");

halImageContainer.forEach((container) => {
	container.querySelectorAll('.hal-dot').forEach((dot, i) => {
		dot.addEventListener('click', () => {
			resetHal();
			dot.offsetParent
				.querySelectorAll('.hal-productCard')
				[i].classList.add('active');
			dot.classList.add('active');
			dot.offsetParent
				.querySelector('.hal-productCard--wrapper')
				.classList.add('active');
		});
	});
});

function resetHal() {
	if (document.querySelector('.hal-productCard--wrapper.active') !== null) {
		document
			.querySelector('.hal-productCard--wrapper.active')
			.classList.remove('active');
		document
			.querySelector('.hal-productCard.active')
			.classList.remove('active');
		document.querySelector('.hal-dot.active').classList.remove('active');
	}
}

jQuery.getJSON(window.Shopify.routes.root + 'products/jc70002t.js', function(product) {
	console.log('The title of this product is ' + product.featured_image);
  } );

